import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Report from './loanRepayment/report';
import { resetReports } from './actions';
import ExportCsvButton from './filters/ExportCsvButton';
import Layout from './components/Layout';
class LoanRepaymentReport extends Component {

  componentWillUnmount() {
    this.props.resetReports();
  }

  render() {
    return (
      <Layout title="Reports">
        <div className="u-text-right">
          <ExportCsvButton
            csv={this.props.csv}
          />
        </div>
        <Report />
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  shop: state.auth.shop,
});

const mapDispatchToProps = {
  resetReports,
};

LoanRepaymentReport.propTypes = {
  resetReports: PropTypes.func.isRequired,
  csv: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoanRepaymentReport);
